import React, { useState } from "react";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
      setEmail("");
    }
  };

  return (
    <footer className="bg-gradient-to-b from-slate-900 via-indigo-950 to-slate-950 text-slate-300 pt-16 pb-8 px-4 lg:px-12 relative z-10 border-t border-purple-500/20">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-12 border-b border-slate-800/80">
          {/* Brand Column */}
          <div className="md:col-span-4 space-y-4">
            <a href="/" className="flex items-center gap-3 group inline-flex">
              <div className="w-12 h-12 rounded-2xl overflow-hidden shadow-lg shadow-purple-500/20 border-2 border-purple-400/50 bg-white flex items-center justify-center p-0.5 group-hover:scale-105 transition-transform duration-300">
                <img
                  src="/image/logo.jpg"
                  alt="KidsGuru Logo"
                  className="w-full h-full object-cover rounded-xl"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/image/logo.webp";
                  }}
                />
              </div>
              <div className="flex flex-col">
                <span className="heading-font text-2xl font-bold bg-gradient-to-r from-pink-400 via-purple-300 to-amber-300 bg-clip-text text-transparent">
                  KidsGuru
                </span>
                <span className="text-[10px] font-semibold tracking-wider text-purple-400 uppercase">
                  Interactive Learning
                </span>
              </div>
            </a>
            <p className="text-xs leading-relaxed text-slate-400 max-w-sm">
              Turn everyday screen time into early learning success with ad-free games, phonics, numbers, and multilingual vocabulary built for young minds.
            </p>
            {/* Social Pill Badges */}
            <div className="flex items-center gap-2 pt-2">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-xl bg-white/5 hover:bg-pink-500/20 text-slate-300 hover:text-pink-400 border border-white/10 flex items-center justify-center transition-all hover:scale-110"
                aria-label="Facebook"
              >
                <i className="fa-brands fa-facebook-f text-xs"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-xl bg-white/5 hover:bg-purple-500/20 text-slate-300 hover:text-purple-400 border border-white/10 flex items-center justify-center transition-all hover:scale-110"
                aria-label="Instagram"
              >
                <i className="fa-brands fa-instagram text-xs"></i>
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-xl bg-white/5 hover:bg-rose-500/20 text-slate-300 hover:text-rose-400 border border-white/10 flex items-center justify-center transition-all hover:scale-110"
                aria-label="YouTube"
              >
                <i className="fa-brands fa-youtube text-xs"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-xl bg-white/5 hover:bg-blue-500/20 text-slate-300 hover:text-blue-400 border border-white/10 flex items-center justify-center transition-all hover:scale-110"
                aria-label="Twitter"
              >
                <i className="fa-brands fa-twitter text-xs"></i>
              </a>
            </div>
          </div>

          {/* Quick Nav Links */}
          <div className="md:col-span-2">
            <h5 className="heading-font text-white font-bold text-sm tracking-wide mb-4 flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-pink-500"></span> Explore
            </h5>
            <ul className="space-y-2.5 text-xs">
              <li>
                <a href="/#features" className="hover:text-pink-400 transition-colors flex items-center gap-1.5">
                  <i className="fa-solid fa-chevron-right text-[9px] text-purple-400"></i> Features
                </a>
              </li>
              <li>
                <a href="/#demo" className="hover:text-pink-400 transition-colors flex items-center gap-1.5">
                  <i className="fa-solid fa-chevron-right text-[9px] text-purple-400"></i> Mini Game Demo
                </a>
              </li>
              <li>
                <a href="/#preview" className="hover:text-pink-400 transition-colors flex items-center gap-1.5">
                  <i className="fa-solid fa-chevron-right text-[9px] text-purple-400"></i> App Peek
                </a>
              </li>
              <li>
                <a href="/#languages" className="hover:text-pink-400 transition-colors flex items-center gap-1.5">
                  <i className="fa-solid fa-chevron-right text-[9px] text-purple-400"></i> Multi-Language
                </a>
              </li>
            </ul>
          </div>

          {/* Support Links */}
          <div className="md:col-span-2">
            <h5 className="heading-font text-white font-bold text-sm tracking-wide mb-4 flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-teal-400"></span> Safety & Help
            </h5>
            <ul className="space-y-2.5 text-xs">
              <li>
                <a href="/#top" className="hover:text-teal-300 transition-colors flex items-center gap-1.5">
                  <i className="fa-solid fa-chevron-right text-[9px] text-teal-400"></i> Parent Guide
                </a>
              </li>
              <li>
                <a href="/#top" className="hover:text-teal-300 transition-colors flex items-center gap-1.5">
                  <i className="fa-solid fa-chevron-right text-[9px] text-teal-400"></i> Privacy Policy
                </a>
              </li>
              <li>
                <a href="/#top" className="hover:text-teal-300 transition-colors flex items-center gap-1.5">
                  <i className="fa-solid fa-chevron-right text-[9px] text-teal-400"></i> Terms of Service
                </a>
              </li>
              <li>
                <a href="/#top" className="hover:text-teal-300 transition-colors flex items-center gap-1.5">
                  <i className="fa-solid fa-chevron-right text-[9px] text-teal-400"></i> Contact Support
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter Column */}
          <div className="md:col-span-4">
            <div className="bg-white/5 border border-white/10 rounded-2xl p-5 backdrop-blur-md">
              <h5 className="heading-font text-white font-bold text-sm tracking-wide mb-1 flex items-center gap-2">
                <i className="fa-solid fa-envelope-open-text text-amber-400"></i> Parent Newsletter
              </h5>
              <p className="text-xs text-slate-400 mb-4">
                Subscribe for fun printable activity sheets & learning tips.
              </p>
              {subscribed ? (
                <div className="text-xs font-bold text-emerald-400 p-2 bg-emerald-500/10 rounded-xl border border-emerald-500/20 text-center">
                  ✓ Thanks for joining our newsletter!
                </div>
              ) : (
                <form onSubmit={handleSubscribe} className="space-y-2">
                  <div className="relative">
                    <input
                      type="email"
                      placeholder="Enter parent's email..."
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      className="w-full bg-slate-900/90 border border-purple-500/30 text-white placeholder-slate-500 text-xs px-3.5 py-2.5 rounded-xl focus:outline-none focus:border-purple-400 transition-colors"
                    />
                  </div>
                  <button
                    type="submit"
                    className="w-full bg-gradient-to-r from-pink-500 to-purple-600 hover:from-pink-600 hover:to-purple-700 text-white px-4 py-2.5 rounded-xl text-xs font-bold transition-all shadow-md active:scale-95 flex items-center justify-center gap-2"
                  >
                    <span>Join Free Newsletter</span>
                    <i className="fa-solid fa-paper-plane text-[10px]"></i>
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>

        {/* Bottom Copyright Bar */}
        <div className="pt-6 flex flex-col sm:flex-row items-center justify-between text-xs text-slate-400 gap-4">
          <div className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse"></span>
            <span>100% Kid-Safe & COPPA Certified Environment</span>
          </div>
          <div>&copy; {new Date().getFullYear()} KidsGuru. All rights reserved.</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
